import { Icon } from './Icon';

interface Props {
  checked: boolean;
}

export function Checkbox({ checked }: Props) {
  return (
    <span class={`check ${checked ? 'check--on' : ''}`} aria-hidden="true">
      {checked ? <Icon name="check" size={14} /> : null}
    </span>
  );
}
